module.exports = __webpack_public_path__ + "img/CSS-logo.94801ff5.svg";